import Cookies from "js-cookie";

export default function bypassMaintenanceMode() {
  const queryParams = window.location.search.replace("?", "")
    .split("&")
  const bypassMaintenanceModeToken = queryParams.find((el) => el.startsWith("qcpass"))
    ?.split("=")[1] || null

  if (bypassMaintenanceModeToken) {
    Cookies.set("qcpass", bypassMaintenanceModeToken, { expires: 1 })
  }
}
